"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {
    base: {
        white: '#FFF',
        black: '#000',
        default: '#333',
        gray: '#979797',
        grayDarkest: '#676767',
        grayDark: '#636363',
        grayMedium: '#A8A8A8',
        grayLight: '#D9D9D9',
        grayLightest: '#F1F1F1',
        blueDarker: '#097093',
        blue: '#0a84ae',
        blueLight: '#44c7f4',
        blueLightest: '#f5f7f9',
        orange: '#eb5424',
        orangeLighter: '#ff784d',
        orangeLightest: '#ffb299',
        orangeDark: '#FF3E00',
        greenDarker: '#3F6910',
        green: '#4CD964',
        red: '#FF0000',
        redDarker: '#801F00',
        yellow: '#786600',
        text: undefined
    },
    text: {
        default: '#212121',
        inputs: '#555',
        secondary: '#757575',
        subtle: '#BDBDBD',
        error: '#FF0000'
    },
    form: {
        title: '#000',
        divider: 'rgba(151,151,151,0.29)',
        background: '#f9f9f9'
    },
    input: {
        background: '#FFF',
        backgroundReadOnly: '#F3F4F4',
        border: '#CCCCCC',
        borderHover: '#B7B7B7',
        borderFocus: '#0a84ae',
        borderError: '#FF0000',
        icon: '#A2A2A2',
        text: '#333',
        placeholder: '#B2B2B2',
        placeholderDisabled: '#C1C1C1',
        placeholderReadOnly: '#333',
        label: '#333',
        labelDisabled: '#C6C6C6'
    },
    link: {
        default: '#0a84ae',
        defaultHover: '#053b4e',
        defaultFocus: '#053b4e',
        sidebar: '#333',
        sidebarHover: '#FF3E00',
        sidebarFocus: '#FF3E00'
    },
    tooltip: {
        background: '#1A1A1A',
        text: '#FFF'
    },
    tabs: {
        default: '#212121',
        defaultHover: '#0a84ae'
    },
    button: {
        default: {
            background: '#F1F1F1',
            backgroundHover: '#E9E8E8',
            backgroundFocus: '#E9E8E8',
            backgroundActive: '#DADADA',
            text: '#333',
            icon: 'default',
            border: '#F1F1F1',
            borderHover: '#E9E8E8',
            borderFocus: '#E9E8E8',
            borderActive: '#DADADA'
        },
        primary: {
            background: '#44C7F4',
            backgroundHover: '#13B7ED',
            backgroundFocus: '#13B7ED',
            backgroundActive: '#11A7D9',
            text: '#FAFAFA',
            icon: 'white',
            border: '#44C7F4',
            borderHover: '#13B7ED',
            borderFocus: '#13B7ED',
            borderActive: '#11A7D9'
        },
        secondary: {
            background: 'transparent',
            backgroundHover: 'rgba(0,0,0,0.05)',
            backgroundFocus: 'rgba(0,0,0,0.05)',
            backgroundActive: '#DADADA',
            text: '#333',
            icon: 'default',
            border: '#D0D2D3',
            borderHover: '#B5B7B8',
            borderFocus: '#B5B7B8',
            borderActive: '#DADADA'
        },
        cta: {
            background: '#EB5424',
            backgroundHover: '#D94514',
            backgroundFocus: '#D94514',
            backgroundActive: '#BF3A11',
            text: '#FAFAFA',
            icon: 'white',
            border: '#EB5424',
            borderHover: '#D94514',
            borderFocus: '#D94514',
            borderActive: '#BF3A11'
        },
        destructive: {
            background: '#FF0000',
            backgroundHover: '#E40002',
            backgroundFocus: '#E40002',
            backgroundActive: '#BE0001',
            text: '#FAFAFA',
            icon: 'white',
            border: '#FF0000',
            borderHover: '#E40002',
            borderFocus: '#E40002',
            borderActive: '#BE0001'
        },
        success: {
            background: '#4CD964',
            backgroundHover: '#4CD964',
            backgroundFocus: '#4CD964',
            text: '#FAFAFA',
            icon: 'white',
            border: '#4CD964',
            borderHover: '#4CD964',
            borderFocus: '#4CD964',
            borderActive: '#4CD964',
            backgroundActive: undefined
        },
        link: {
            text: '#0a84ae',
            icon: 'blue',
            hover: '#0a84ae',
            focus: '#0a84ae'
        }
    },
    icon: {
        default: '#333',
        light: '#A8A8A8',
        sidebar: 'default',
        sidebarHover: 'orangeDark',
        sidebarFocus: 'orangeDark'
    },
    list: {
        backgroundHover: '#FAFAFA',
        borderColor: '#DDD'
    },
    alert: {
        default: {
            background: '#F0F0F0',
            text: '#333'
        },
        information: {
            background: '#DBF4FC',
            text: '#097093'
        },
        success: {
            background: '#E5F8D1',
            text: '#3F6910'
        },
        warning: {
            background: '#FFF6CB',
            text: '#786600'
        },
        danger: {
            background: '#FFD8CC',
            text: '#801F00'
        }
    },
    radio: {
        background: '#FFF',
        border: '#BEBEBE',
        backgroundSelected: '#3B99FC',
        borderSelected: '#2C90FC',
        backgroundDisabled: '#F6F6F6',
        borderDisabled: '#CCC',
        shadow: 'rgba(0,0,0,0.20)',
        shadowDisabled: 'rgba(0,0,0,0.10)'
    },
    status: {
        default: '#7D7D7D',
        information: '#3BC0F2',
        success: '#73CD1F',
        warning: '#F49C20',
        danger: '#D14B49'
    },
    tag: {
        background: '#DBF4FD',
        border: '#3BC0F2',
        text: '#3BC0F2'
    }
};
exports.default = colors;
//# sourceMappingURL=colors.js.map